function Liechtenstein({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1535)">
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0.695625 16 16 13.9131 16 13.9131L32 16Z" fill="#D80027"/>
  <path d="M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16" fill="#0052B4"/>
  <path d="M11.8261 11.1303C11.8261 9.97774 10.8917 9.04337 9.73914 9.04337C9.20445 9.04337 8.71714 9.24462 8.34783 9.57518V8.34768H9.04345V6.95637H8.34783V6.26074H6.95652V6.95637H6.26089V8.34768H6.95652V9.57518C6.58721 9.24462 6.09989 9.04337 5.56521 9.04337C4.41265 9.04337 3.47827 9.97774 3.47827 11.1303C3.47827 11.7482 3.74708 12.3032 4.1739 12.6854V13.9129H11.1304V12.6854C11.5573 12.3032 11.8261 11.7482 11.8261 11.1303Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Liechtenstein;
